// Tripadvisor.js
import React, { useState } from "react";
import LanguageModal from "./LanguageModal";

const Tripadvisor = () => {
  const [showModal, setShowModal] = useState(false);

  const links = {
    en: "https://www.tripadvisor.es/Hotel_Review-g580312-d267051-Reviews-Hotel_Condesa-Port_d_Alcudia_Alcudia_Majorca_Balearic_Islands.html",
  };

  return (
    <>
      {/* biome-ignore lint/a11y/useButtonType: <explanation> */}
      <button className="full-width-button" onClick={() => setShowModal(true)}>
        <i className="fa fa-tripadvisor icon-adjusted" />
        Tripadvisor
      </button>
      {showModal && (
        <LanguageModal
          title="Tripadvisor"
          icon="fa fa-tripadvisor"
          links={links}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default Tripadvisor;
